import { createAction, props } from '@ngrx/store';
import { Languages, Provinces } from '@rci/common';
import { LoginState } from '@rci/state-service';

export type Language = Languages;
export type Province = Provinces;

export enum CommonActionTypes {
  SetLanguage = '[Common] Set Language',
  SetProvince = '[Common] Set Province',
  SetUserLoginState = '[Common] Set User Login State',
}

// Union the valid types
export const setLanguage = createAction(CommonActionTypes.SetLanguage, props<{ language: string }>());
export const setProvince = createAction(CommonActionTypes.SetProvince, props<{ province: string }>());
export const setUserLoginState = createAction(CommonActionTypes.SetUserLoginState, props<{ loginState: LoginState }>());
